import script from "./ProfileChildRemoveModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileChildRemoveModal.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileChildRemoveModal.vue?vue&type=style&index=0&id=1ccce977&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ccce977"]])

export default __exports__